import { observer } from 'mobx-react-lite'
import { Navigate, Outlet } from 'react-router'
import { useEffect, useMemo, useState } from 'react'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { ChatbotLayoutStore } from 'pages/chatbot'
import { ChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'

export const ChatbotLayout = observer(() => {
  const entities = useEntitiesContext()
  const { mergeFieldStore, integrationsStore } = entities
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const pageStore = useMemo(() => new ChatbotLayoutStore(menuLayoutStore.pageLayoutStore), [])
  const canAccessChatbot = checkAccessPage(EnumAccessPageKeys.chatbot, entities)
  const [loading, setLoading] = useState(true)

  if (!canAccessChatbot) return <Navigate to={'/'} replace />

  useEffect(() => {
    Promise.all([integrationsStore.fetchIntegrations(), mergeFieldStore.loadAllFields()]).then(
      () => {
        setLoading(false)
      }
    )
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'ChatbotLayout'} />

  return (
    <ChatbotLayoutContext.Provider value={pageStore}>
      <Outlet />
    </ChatbotLayoutContext.Provider>
  )
})
